import { useEffect, useMemo, useState } from 'react';

/**
 * Subscribes to a viewport media query for compact vs full glass widget carousel mode.
 *
 * @param options
 */
const useGlassWidgetCompactViewport = (options) => {
  const { compactViewportMaxHeightPx, compactMaxVisibleGlassCardSlots } = options;

  const mediaQuery = useMemo(() => {
    const override = options.compactViewportMediaQuery;
    if (override != null && override !== '') {
      return override;
    }
    return `(max-height: ${compactViewportMaxHeightPx}px)`;
  }, [options.compactViewportMediaQuery, compactViewportMaxHeightPx]);

  const [isGlassWidgetCompactViewport, setIsGlassWidgetCompactViewport] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(mediaQuery).matches : false,
  );

  useEffect(() => {
    const mq = window.matchMedia(mediaQuery);
    const syncCompactViewport = () => setIsGlassWidgetCompactViewport(mq.matches);
    syncCompactViewport();
    mq.addEventListener('change', syncCompactViewport);
    return () => mq.removeEventListener('change', syncCompactViewport);
  }, [mediaQuery]);

  const maxVisibleGlassWidgetCardSlots = isGlassWidgetCompactViewport
    ? compactMaxVisibleGlassCardSlots
    : Number.POSITIVE_INFINITY;

  return { isGlassWidgetCompactViewport, maxVisibleGlassWidgetCardSlots };
};

export default useGlassWidgetCompactViewport;
